import Service, { service } from '@ember/service';
import { cached } from '@glimmer/tracking';
import dateUtils from 'donor-elf-web/lib/date-utils';
import Settings from './settings';
import FundsService from './funds-service';
import moment from 'moment';

export default class FundGoalService extends Service {
  @service declare fundsService: FundsService;
  @service declare settings: Settings;

  @cached
  get hasYtdGoalType() {
    return (
      this.fundsService.goal?.goalType === 'ytd' ||
      this.settings.fundSettings?.defaultGoalType === 'ytd'
    );
  }

  @cached
  get hasTotalAndExpectingGoalType() {
    return (
      this.fundsService.goal?.goalType === 'total_and_expecting' ||
      this.settings.fundSettings?.availableGoalTypes?.toString() ===
        'total_and_expecting'
    );
  }

  @cached
  get hasTotalOrTotalAndExpectingGoalType() {
    return (
      this.fundsService.goal?.goalType === 'total' ||
      this.fundsService.goal?.goalType === 'total_and_expecting'
    );
  }

  @cached
  get ytdStartMoment() {
    if (!this.hasYtdGoalType) {
      return null;
    }

    let startAtMonth;
    if (this.settings.fundSettings?.ytdStartAt) {
      startAtMonth = this.settings.fundSettings.ytdStartAt.getMonth() + 1;
    } else if (this.settings.orgSettings?.ytdStartAtMonth) {
      startAtMonth = this.settings.orgSettings.ytdStartAtMonth;
    } else {
      startAtMonth = new Date().getMonth() + 1;
    }

    let startDate = dateUtils.deserializeDateOnly(
      `${new Date().getFullYear()}-${startAtMonth.toString().padStart(2, '0')}-01`,
    );
    if (startDate > new Date()) {
      startDate = moment(startDate).subtract(1, 'years').toDate();
    }
    return moment(startDate);
  }
}
